<template>
  <el-container>
    <el-main>
      <el-form ref="form" label-width="80px">
        <div v-for="(item, index) in positionList" :key="index">
          <el-divider content-position="left">{{positionName}}职务 {{index+1}}</el-divider>
          <el-form-item label="职务名称">
            <el-input @change="change($event, item, index)" v-model="item.position_name"></el-input>
          </el-form-item>
          <el-form-item label="在职时间">
            <el-date-picker
              @blur="change($event, item, index)"
              v-model="item.date"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" @click="addPosition" icon="el-icon-plus">添加{{positionName}}职务信息</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
import { mapState } from "vuex";
import $http from "../../../request.js";
import _ from "lodash";
export default {
  name: "position",
  created(){
    this.updatePositionList(this.list);
  },
  computed:{
    ...mapState([
      "defaultInfo",
      "area"
    ])
  },
  props:{
    list:{
      type: Array,
      default:function(){
        return [];
      }
    },
    positionName: {
      type: String,
      default: ""
    },
    positionType: {
      type: [String, Number],
      default: ""
    }
  },
  watch:{
    list(list){
      this.updatePositionList(list);
    }
  },
  data(){
    return {
      positionList: [
        {
          position_name: "",
          date: ""
        }
      ]
    };
  },
  methods:{
    updatePositionList(list){
      this.positionList = [];
      this.positionList = list.map(v=>{
        v.date = [
          v.start_date,
          v.end_date
        ];
        return v;
      });
    },
    addPosition(){
      this.positionList = [
        ...this.positionList,
        {
          position_name: "",
          date: ""
        }
      ]
    },
    updatePosition(params) {
      let url = "/api/member/member_position/add";
      if(params.id) {
        url = "/api/member/member_position/edit";
      }
      $http.post(url, params)
        .then(res=>{
          if (res.data.code===1){
            this.$message({
              message: params.id?"修改成功":"新增成功",
              type: 'success'
            });
            this.$emit('success');
          }
        });
    },
    change(e, item, index) {
      this.positionList[index] = item;
      const params = {
        id: item.id||'',
        position_type: this.positionType,
        position_name: item.position_name,
        start_date: item.date[0],
        end_date: item.date[1]
      }
      let toupdate = true;
      _.forIn(params, (val, key)=>{
        if (!val&&key!=='id') {
          toupdate = false;
        }
      });
      if (toupdate) {
        this.updatePosition(params);
      }
    }
  }
};
</script>

<style lang="less">
  
</style>

